<template>
    <div class="auth-btn-group">
        <Button
            v-for="(item, index) in currentAuthBtn"
            :key="index"
            type="primary"
            @click="handleClick(item)"
            >{{ item.resourceName }}</Button
        >
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: 'AuthButtonGroup',
    computed: {
        ...mapState({
            currentAuthBtn: (state) => state.comon.currentAuthBtn,
        }),
    },
    methods: {
        handleClick(item) {
            this.$emit('click', item);
        },
    },
};
</script>

<style lang="less" scoped>
.auth-btn-group {
    display: inline-block;
}
</style>
